import { Chip } from "@mui/material";
import { PAYMENT_STATUS_CONFIG } from "../../constants/paymentStatus";
import { useAppTranslation } from "../../hooks/useAppTranslation";

interface Props {
  status?: string | null;
}

export default function PaymentStatusChip({ status }: Props) {
  const { t } = useAppTranslation("common");

  // 🔥 normalizacja statusu
  const normalized =
    typeof status === "string" && status.trim()
      ? status
      : "__EMPTY__";

  const config =
    PAYMENT_STATUS_CONFIG[normalized] ?? {
      label: normalized,
      color: "default" as const,
    };

  return (
    <Chip
      size="small"
      label={t(normalized, {}, "payments")}
      color={config.color}
      variant="outlined"
    />
  );
}